import cmp from './ThemeSnackbar'

export default cmp
